<template>
    <vx-expandable-card>
        <template v-slot:header>Type</template>
        <template v-if="setByCorp" v-slot:headerRight>
            <vx-popover hover arrow placement="top">
                <vx-badge size="2xs" color="slate" class="cursor-default">
                    Set by Corp
                    <font-awesome-icon :icon="faCrown"></font-awesome-icon>
                </vx-badge>
                <template v-slot:content>
                    <div class="text-center">
                        {{ corporateMessage }}
                    </div>
                </template>
            </vx-popover>
        </template>
        <template v-slot:content>
            <div class="flex flex-col items-start">
                <strong
                    :id="audienceTypeLabelId"
                    class="text-slate-900 text-sm font-semibold sm:text-base sm:leading-6"
                >
                    What audience type are you messaging?
                </strong>
                <span class="text-slate-500 text-xs font-normal mb-2">
                    This selection will limit the Segments you can send to.
                </span>
            </div>

            <vx-radio-selection v-model="type" manualActivation :aria-labelledby="audienceTypeLabelId">
                <vx-radio-selection-item
                    v-if="marketingAllowed"
                    :value="AUDIENCE_TYPE_MARKETING"
                    data-test="quick-blast-type-marketing"
                >
                    <template v-slot:header> Marketing </template>
                    <template v-slot:content>
                        <ul
                            class="list-disc list-outside ml-10 @md/item:ml-4"
                            v-html="audienceTypeDescription(AUDIENCE_TYPE_MARKETING)"
                        ></ul>
                    </template>
                </vx-radio-selection-item>
                <vx-radio-selection-item
                    v-if="transactionalAllowed"
                    :value="AUDIENCE_TYPE_TRANSACTIONAL"
                    data-test="quick-blast-type-transactional"
                >
                    <template v-slot:header> Transactional </template>
                    <template v-slot:content>
                        <ul
                            class="list-disc list-outside ml-10 @md/item:ml-4"
                            v-html="audienceTypeDescription(AUDIENCE_TYPE_TRANSACTIONAL)"
                        ></ul>
                    </template>
                </vx-radio-selection-item>
            </vx-radio-selection>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import {
    VxExpandableCard,
    VxRadioSelection,
    VxRadioSelectionItem,
    VxBadge,
    VxPopover,
} from '@voxie/frontend-components';
import { audienceTypeDescription, AUDIENCE_TYPE_MARKETING, AUDIENCE_TYPE_TRANSACTIONAL } from '~/constants/campaign';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCrown } from '@fortawesome/pro-solid-svg-icons';
import { useMessageRules } from '~/components/quick-blast/useMessageRules';
import { computed, useId, watch } from 'vue';

const type = defineModel({
    type: String,
});

const audienceTypeLabelId = useId();

const { marketingAllowed, transactionalAllowed } = useMessageRules();

const setByCorp = computed(() => {
    return marketingAllowed.value !== transactionalAllowed.value;
});

const corporateMessage = computed(() => {
    if (!setByCorp.value || !type.value) {
        return '';
    }

    const typeLabel = type.value.charAt(0).toUpperCase() + type.value.slice(1);
    return `Corporate has limited quick blast to ${typeLabel} campaigns only.`;
});

watch(
    [marketingAllowed, transactionalAllowed],
    ([marketing, transactional]) => {
        const onlyOneEnabled = marketing !== transactional;

        if (onlyOneEnabled && !type.value) {
            type.value = marketing ? AUDIENCE_TYPE_MARKETING : AUDIENCE_TYPE_TRANSACTIONAL;
        }
    },
    { immediate: true }
);
</script>
